import { toast } from '@/components/ui/toast-store'
import { featureCopy } from '@/features/subscriptions/lib/features'

/**
 * "Alerts needs a paid plan" — or the generic fallback when the key carries
 * no web copy (`featureCopy` only knows the keys `features.ts` has labelled).
 */
export const upgradeTitle = (featureKey: string): string => {
  const label = featureCopy(featureKey)?.label
  return label === undefined ? 'This feature needs a paid plan' : `${label} needs a paid plan`
}

/**
 * The write-side counterpart (CONTRACT §7: creating an alert, adding to a
 * watchlist, saving an import). The surrounding form or dialog stays usable —
 * a page-level block would be wrong for "this one click was refused" — so a
 * toast says why and offers the same way out.
 *
 * `onSeePlans` rather than a bound `navigate`: the caller's own `useNavigate()`
 * has a route-typed `to`, which a loosely-typed param here could not accept
 * contravariantly — a zero-arg callback sidesteps that.
 */
export function upgradeToast(featureKey: string, onSeePlans: () => void): void {
  toast.error(upgradeTitle(featureKey), { label: 'See plans', onClick: onSeePlans })
}
